import React, { useState, useEffect } from "react";
import { Segment, Image, List } from "semantic-ui-react";

import Advertisers from "./advertisers";
import Templates from "./templates";

const Retailer = ({ retailer }) => {
  const [showComponent, setShowComponent] = useState();

  const handleEdit = (component) => {
    setShowComponent(component);
  };

  useEffect(() => {
    if (retailer && !retailer.name) {
      setShowComponent("templates");
    }
    return () => {
      setShowComponent(null);
    };
  }, [retailer]);

  return (
    <>
      {retailer.name && (
        <Segment>
          {retailer.logo && <Image size="tiny" src={retailer.logo} />}
          <List divided relaxed>
            <List.Item>
              <List.Icon
                link
                color="blue"
                name="edit"
                onClick={() => handleEdit("templates")}
                size="large"
                verticalAlign="middle"
              />
              <List.Content>
                <List.Header>Templates</List.Header>
                <List.Description>
                  <List bulleted horizontal>
                    {retailer.templates.map((template) => (
                      <List.Item key={template.name}>
                        {template.displayName}
                      </List.Item>
                    ))}
                  </List>
                </List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon
                link
                color="blue"
                name="edit"
                onClick={() => handleEdit("advertisers")}
                size="large"
                verticalAlign="middle"
              />
              <List.Content>
                <List.Header>Advertisers</List.Header>
              </List.Content>
            </List.Item>
          </List>
        </Segment>
      )}
      {showComponent === "advertisers" && <Advertisers retailer={retailer} />}
      {showComponent === "templates" && <Templates activeItem={retailer} />}
    </>
  );
};

export default Retailer;
